import { useMemo } from 'react';
import { useAuthStore } from '@stores/auth.store';

const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';

function buildInputFormats(primary) {
    const common = [
        'DD/MM/YYYY',
        'D/M/YYYY',
        'DD-MM-YYYY',
        'D-M-YYYY',
        'DD.MM.YYYY',
        'D.M.YYYY',
        'MM/DD/YYYY',
        'M/D/YYYY',
        'YYYY-MM-DD',
        'YYYY/MM/DD',
        'DD MMM YYYY',
        'D MMM YYYY',
        'MMM D, YYYY',
        'MMMM D, YYYY',
        'MMMM D/YYYY',
    ];
    const list = [primary, ...common].filter(Boolean);
    return Array.from(new Set(list));
}

export function useTenantDateFormat() {
    const dateFormat = useAuthStore((s) => s.user?.preferences?.dateFormat) || DEFAULT_DATE_FORMAT;
    const dateTimeFormat = useMemo(() => `${dateFormat} hh:mm A`, [dateFormat]);
    const dateInputFormats = useMemo(() => buildInputFormats(dateFormat), [dateFormat]);
    return { dateFormat, dateTimeFormat, dateInputFormats };
}

